import React, { useCallback, useContext, useEffect, useRef, useState } from "react";

import "./Home.css";
import "./Home-layout1-crystal.css";
import "./Home-layout2-dark.css";

import Header from "../../components/header/Header";

import HeroCarousel from "../../components/Carousel";

import AdCarousel from "../../components/AdCarousel/AdCarousel";

import CategoreyCard from "../../components/CategoreyCard";

import SmallCategorySlider from "../../components/SmallCategorySlider/SmallCategorySlider";

import ProductCard from "../../components/ProductCard";

import BottomNav from "../../components/Bottom nav/BottomNav";

import { Box, CircularProgress, Grid, Typography, Skeleton } from "@mui/material";
import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import GridViewIcon from "@mui/icons-material/GridView";
import GroupsIcon from "@mui/icons-material/Groups";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

import { useHistory } from "react-router-dom";

import { variableContext } from "../../context/VariableContex";

import { useMediaQuery } from "@mui/material";

import useBusinessQuery from "../../store/Bussiness/useBusinessQuery";

import useCommonQuery from "../../store/common/useCommonQuery";

import RegistrationErrorModal from "../../components/registrationModal/RegistrationErrorModal";

import axios from "axios";

import Empty from "../../assets/Empty.mp4";

import BottomIcons from "../../components/BottomIcons/Index";

import { Virtuoso } from 'react-virtuoso'

import useUserLocation from "../../hooks/useUserLocation";
import TrendingCategoriesBar from "../../components/TrendingCategoriesBar/TrendingCategoriesBar";

// Custom BUY ↔️ SELL Icon Component
const BuySellIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* BUY box on left */}
    <rect x="2" y="8" width="7" height="8" rx="1" fill="currentColor" fillOpacity="0.9" stroke="currentColor" strokeWidth="0.5" />
    <text x="5.5" y="13.5" fontSize="4" fontWeight="bold" fill="white" textAnchor="middle">BUY</text>

    {/* SELL box on right */}
    <rect x="15" y="8" width="7" height="8" rx="1" fill="currentColor" fillOpacity="0.9" stroke="currentColor" strokeWidth="0.5" />
    <text x="18.5" y="12.2" fontSize="3.5" fontWeight="bold" fill="white" textAnchor="middle">SELL</text>

    {/* Curved arrow from BUY to SELL (top) */}
    <path
      d="M 9.5 9.5 Q 12 7 14.5 9.5"
      stroke="currentColor"
      strokeWidth="1.2"
      fill="none"
      strokeLinecap="round"
    />
    <polygon points="14.5,9.5 13.5,8.5 15.5,9 14,10.5" fill="currentColor" />

    {/* Curved arrow from SELL to BUY (bottom) */}
    <path
      d="M 14.5 14.5 Q 12 17 9.5 14.5"
      stroke="currentColor"
      strokeWidth="1.2"
      fill="none"
      strokeLinecap="round"
    />
    <polygon points="9.5,14.5 10.5,15.5 8.5,15 10,13.5" fill="currentColor" />
  </svg>
);



const Home = () => {

  const history = useHistory();

  const { locationData, setLocationFilter } = useContext(variableContext);

  const { layoutMode } = useContext(variableContext);
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(min-width:601px) and (max-width:1023px)");
  const isLayout2 = isMobile && layoutMode === "list";



  // Use optimized geolocation hook with caching

  // This provides instant location from cache, then refreshes in background

  // and automatically updates context when new location is detected

  const { location: optimizedLocation } = useUserLocation({

    enableBackgroundRefresh: true,

    onLocationChange: (newLocation) => {

      // Automatically update context when location changes

      setLocationFilter('latitude', newLocation.latitude);

      setLocationFilter('longitude', newLocation.longitude);

    },

  });



  const Api_Key = "AIzaSyDMC5uUfcSScgVY9AGqsGQwYm8P6_LmyYg";



  const [premium, setPremium] = useState([]);

  const [openLocation, setOpenLocation] = useState(false);

  const [businessPage, setBusinessPage] = useState(0);

  const [hasMoreBusinesses, setHasMoreBusinesses] = useState(true);

  const [loadingMoreBusinesses, setLoadingMoreBusinesses] = useState(false);

  const [hideCarousels, setHideCarousels] = useState(false);
  const fourBtnRowRef = useRef(null);
  const [singleBtnWidth, setSingleBtnWidth] = useState(null);

  // Measure the 4-button row on desktop to get exact single-button width
  useEffect(() => {
    if (isMobile || isTablet) return;
    const measure = () => {
      if (!fourBtnRowRef.current) return;
      const btns = fourBtnRowRef.current.querySelectorAll('.quick-btn');
      if (btns.length > 0) {
        setSingleBtnWidth(btns[0].getBoundingClientRect().width);
      }
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [isMobile, isTablet]);



  const query = {

    latitude: locationData?.latitude,

    longitude: locationData?.longitude,

    radius: locationData?.radius || null,

    category: "",

    subCategory: "",

    name: "",

    is_premium: true,  // Only fetch premium businesses
    is_pro: true, // Also fetch pro businesses

    limit: 15,  // Changed to 15

    offset: businessPage * 15,  // Use 15 for pagination

  };



  console.log('🔍 Business Query:', query);

  console.log('📄 Current businessPage:', businessPage);

  console.log('🔢 Calculated offset:', businessPage * 15);



  const { data: categoryList } = useCommonQuery.Get_category({

    search: "",

    limit: 100,

    offset: 0,

  });



  const {

    data: businessList,

    refetch,

    isSuccess,

    isError,

    isLoading

  } = useBusinessQuery.Get_bussiness_list(query);



  const adsQuery = {

    lat: locationData?.latitude,

    lon: locationData?.longitude,

    radius: locationData?.radius || 10,

  };



  const { data: adsData } = useCommonQuery.Get_ads(adsQuery);



  useEffect(() => {

    console.log("Ads API Raw Response:", adsData);

  }, [adsData]);



  const fetchCityName = useCallback(async (latitude, longitude, setLocationFilter) => {

    if (!latitude || !longitude) return; // Avoid unnecessary API calls



    try {

      const response = await Promise.race([

        axios.get(

          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${Api_Key}`

        ),

        new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), 3000))

      ]);



      const results = response.data.results;

      if (results && results.length > 0) {

        const addressComponents = results[0].address_components;

        const city = addressComponents.find(component => component.types.includes("locality"));



        if (city) {

          setLocationFilter('locationName', city.long_name);

        }

      }

    } catch (error) {

      console.error("Error fetching city name:", error);

    }

  }, []);



  const handleClose = useCallback(() => {

    setOpenLocation(false); // Assuming this closes a Snackbar or UI feedback

  }, [])



  const getWebLocation = () =>

    new Promise((resolve, reject) => {

      if (!navigator.geolocation) reject('Geolocation not supported');

      navigator.geolocation.getCurrentPosition(

        position => resolve({

          latitude: position.coords.latitude,

          longitude: position.coords.longitude

        }),

        reject

      );

    });



  const getFlutterLocation = () =>

    new Promise((resolve, reject) => {

      if (!window.LocationChannel) reject('Flutter location not available');



      window.locationCallback = location => {

        const [latitude, longitude] = location.split(',');

        resolve({ latitude, longitude });

      };



      window.LocationChannel.postMessage('getLocation');

    });



  const setLocation = async () => {

    try {

      const coords = await Promise.race([

        getWebLocation(),

        new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), 5000))

      ]);

      setLocationFilter('latitude', coords.latitude);

      setLocationFilter('longitude', coords.longitude);

    } catch {

      try {

        const coords = await Promise.race([

          getFlutterLocation(),

          new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), 3000))

        ]);

        setLocationFilter('latitude', coords.latitude);

        setLocationFilter('longitude', coords.longitude);

      } catch (error) {

        console.error('Location services unavailable:', error);

      }

    }

  };



  useEffect(() => {

    // Use optimized location from cache if context location is not available

    if (!locationData?.latitude || !locationData?.longitude) {

      if (optimizedLocation?.latitude && optimizedLocation?.longitude) {

        setLocationFilter('latitude', optimizedLocation.latitude);

        setLocationFilter('longitude', optimizedLocation.longitude);

      } else {

        setLocation();

      }

    }

  }, [locationData, optimizedLocation]);



  const [prevLocation, setPrevLocation] = useState(null);



  useEffect(() => {

    if (

      locationData?.latitude &&

      locationData?.longitude &&

      (prevLocation?.latitude !== locationData.latitude || prevLocation?.longitude !== locationData.longitude)) {

      fetchCityName(locationData.latitude, locationData.longitude, setLocationFilter);

      setPrevLocation({ latitude: locationData.latitude, longitude: locationData.longitude });

      // Only refetch when location actually changes

      refetch();

    }

  }, [locationData, prevLocation, refetch, fetchCityName]);





  useEffect(() => {

    console.log('🏢 Business Data Effect:', {

      isSuccess,

      businessPage,

      businessListLength: businessList?.data?.length,

      premiumLength: premium?.length

    });



    if (isSuccess && businessList) {

      // Backend already filters for premium businesses, so use all returned data

      if (businessPage === 0) {

        // First page - replace all premium businesses

        console.log('🔄 First page - setting premium businesses:', businessList?.data);

        setPremium([...businessList?.data]);

      } else {

        // Additional pages - append premium businesses

        console.log('➕ Additional page - appending businesses:', businessList?.data);

        setPremium(prev => {

          const newPremium = [...prev, ...(businessList?.data || [])];

          console.log('📊 Updated premium array:', newPremium);

          return newPremium;

        });

      }



      // Check if there are more businesses to load

      if (businessList?.data && (businessList?.data.length < 15 || businessList?.data.length === 0)) {

        console.log('🛑 No more businesses - setting hasMoreBusinesses to false');

        console.log(`📊 Received ${businessList?.data.length} businesses, expected 15`);

        setHasMoreBusinesses(false);

      }



      setLoadingMoreBusinesses(false);

    }

    if (isSuccess || businessList || isError) {

      if (businessList) {

        if (businessList?.data?.length === 0) {

          setHideCarousels(true);

        } else {

          setHideCarousels(false);

        }

      } else {

        setHideCarousels(true);

      }

    }

  }, [isSuccess, businessList, isError, businessPage]);



  const handleClick = (id) => {

    history.push(`/subcategory/${id}`);

  };



  // Handle scroll to load more businesses

  const handleBusinessScroll = useCallback(() => {

    console.log('🔍 Business Scroll Triggered:', {

      loadingMoreBusinesses,

      hasMoreBusinesses,

      isLoading

    });



    if (loadingMoreBusinesses || !hasMoreBusinesses || isLoading) return;



    const scrollElement = document.getElementById("div");

    if (scrollElement) {

      const { scrollTop, scrollHeight, clientHeight } = scrollElement;



      console.log('📏 Scroll Metrics:', {

        scrollTop,

        scrollHeight,

        clientHeight,

        scrollBottom: scrollTop + clientHeight,

        triggerPoint: scrollHeight - 100,

        shouldTrigger: scrollTop + clientHeight >= scrollHeight - 100

      });



      // Load more when user is near bottom (100px from bottom)

      if (scrollTop + clientHeight >= scrollHeight - 100) {

        console.log('🚀 Loading more businesses...');

        console.log('📄 Current page before increment:', businessPage);

        setLoadingMoreBusinesses(true);

        setBusinessPage(prev => {

          const newPage = prev + 1;

          console.log('📄 New page after increment:', newPage);

          return newPage;

        });

      }

    }

  }, [loadingMoreBusinesses, hasMoreBusinesses, isLoading, businessPage]);



  useEffect(() => {

    const scrollElement = document.getElementById("div");

    if (scrollElement) {

      scrollElement.addEventListener("scroll", handleBusinessScroll);

      return () => scrollElement.removeEventListener("scroll", handleBusinessScroll);

    }

  }, [handleBusinessScroll]);






  // OLD six-button sections removed - replaced by new feature/quick-action buttons

  return (

    <div>

      <Header />

      {/* ── LAYOUT 2 MOBILE: flex-column normal flow ── */}
      {isLayout2 ? (
        <div className="layout2-mobile-top">

          {/* 1. Top slideshow */}
          <div className="layout2-ad-carousel">
            <div className="home-left-city-carousel-wrapper">
              <AdCarousel ads={adsData?.data || []} />
            </div>
          </div>

          {/* ═══ NEW: 3 MAIN FEATURE BUTTONS ═══ */}
          <div className="home-main-feature-buttons">
            <div
              className="feature-btn feature-btn--knowledge"
              onClick={() => history.push("/arivum-aarogyavum")}
            >
              <MenuBookIcon className="feature-btn-icon" />
              <span className="feature-btn-label">STUDY MASTER</span>
            </div>
            <div
              className="feature-btn feature-btn--buysell"
              onClick={() => history.push("/used-items")}
            >
              <BuySellIcon className="feature-btn-icon" />
              <span className="feature-btn-label">BUY & SELL</span>
            </div>
            <div
              className="feature-btn feature-btn--doctor"
              onClick={() => history.push("/subcategory/29")}
            >
              <LocalHospitalIcon className="feature-btn-icon" />
              <span className="feature-btn-label">HELLO DOCTOR</span>
            </div>
          </div>

          {/* ═══ NEW: 4 QUICK ACTION BUTTONS ═══ */}
          <div className="home-quick-action-buttons">
            <div
              className="quick-btn quick-btn--newspaper"
              onClick={() => history.push("/news-paper")}
            >
              <NewspaperIcon className="quick-btn-icon quick-btn-icon--newspaper" />
              <span className="quick-btn-label quick-btn-label--newspaper">Newspaper</span>
            </div>
            <div
              className="quick-btn quick-btn--newschannel"
              onClick={() => history.push("/news-channel")}
            >
              <LiveTvIcon className="quick-btn-icon quick-btn-icon--newschannel" />
              <span className="quick-btn-label quick-btn-label--newschannel">News Channel</span>
            </div>
            <div
              className="quick-btn quick-btn--online"
              onClick={() => history.push("/service-link")}
            >
              <LaptopMacIcon className="quick-btn-icon quick-btn-icon--online" />
              <span className="quick-btn-label quick-btn-label--online">Online Service</span>
            </div>
            <div
              className="quick-btn quick-btn--categories"
              onClick={() => history.push("/category-list-view")}
            >
              <GridViewIcon className="quick-btn-icon quick-btn-icon--categories" />
              <span className="quick-btn-label quick-btn-label--categories">All Categories</span>
            </div>
          </div>

          {/* ═══ NEW: Influencer + Recognition BUTTONS (Layout 2 mobile) ═══ */}
          <div className="home-quick-action-buttons home-influencer-recognition-buttons">
            <div
              className="quick-btn quick-btn--influencer"
              onClick={() => history.push("/extra-items/influencers")}
            >
              <GroupsIcon className="quick-btn-icon quick-btn-icon--influencer" />
              <span className="quick-btn-label quick-btn-label--influencer">Influencer</span>
            </div>
            <div
              className="quick-btn quick-btn--recognition"
              onClick={() => history.push("/extra-items/others")}
            >
              <EmojiEventsIcon className="quick-btn-icon quick-btn-icon--recognition" />
              <span className="quick-btn-label quick-btn-label--recognition">Recognition</span>
            </div>
          </div>

          {/* 4. Slideshow — immediately below Influencer/Recognition */}
          <Box className="layout2-hero-carousel" sx={{ padding: "0 17px", '& .carousel': { '& .slide': { borderRadius: '12px', overflow: 'hidden' } } }}>
            <Box sx={{ borderRadius: '10px', overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', border: '1px solid rgba(0,0,0,0.05)' }}>
              <HeroCarousel data={premium} className="hero-carousel-layout2" />
            </Box>
          </Box>

          {/* ═══ TRENDING CATEGORIES — below slideshow (Layout 2 mobile) ═══ */}
          <TrendingCategoriesBar categories={categoryList?.results?.filter(c => c.show_in_home) || []} />

          {/* 5. Five square image buttons (moved below slideshow) */}
          <div className="layout2-five-buttons-row">
            <SmallCategorySlider
              categories={categoryList?.results || []}
              onCategoryClick={handleClick}
              compact={true}
            />
          </div>

          {/* 4. Second slideshow */}
          <Box className="layout2-hero-carousel" sx={{ padding: "0 17px", '& .carousel': { '& .slide': { borderRadius: '12px', overflow: 'hidden' } } }}>
            <Box sx={{ borderRadius: '10px', overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', border: '1px solid rgba(0,0,0,0.05)' }}>
              <HeroCarousel data={premium} className="hero-carousel-layout2" />
            </Box>
          </Box>

        </div>
      ) : (

        /* ── LAYOUT 1 + DESKTOP: original structure unchanged ── */
        <>
          <div className="home-top-grid">

            <div id="div" className="home-left-city" style={{ marginBottom: "0px" }}>

              <Box sx={{
                marginTop: { xs: "114px", md: "168px" },
                padding: { xs: "0px", md: "0px" },
                '& .carousel': { '& .slide': { borderRadius: { xs: '0px', md: '12px' }, overflow: 'hidden' } }
              }}>
                <div className="home-left-city-carousel-wrapper">
                  <AdCarousel ads={adsData?.data || []} />
                </div>
              </Box>

              {/* ═══ NEW: 3 MAIN FEATURE BUTTONS (Layout 1) ═══ */}
              <div className="home-main-feature-buttons home-main-feature-buttons--layout1">
                <div
                  className="feature-btn feature-btn--knowledge"
                  onClick={() => history.push("/arivum-aarogyavum")}
                >
                  <MenuBookIcon className="feature-btn-icon" />
                  <span className="feature-btn-label">STUDY MASTER</span>
                </div>
                <div
                  className="feature-btn feature-btn--buysell"
                  onClick={() => history.push("/used-items")}
                >
                  <ShoppingCartIcon className="feature-btn-icon" />
                  <span className="feature-btn-label">BUY & SELL</span>
                </div>
                <div
                  className="feature-btn feature-btn--doctor"
                  onClick={() => history.push("/subcategory/29")}
                >
                  <LocalHospitalIcon className="feature-btn-icon" />
                  <span className="feature-btn-label">HELLO DOCTOR</span>
                </div>
              </div>

              {/* ═══ NEW: 4 QUICK ACTION BUTTONS (Layout 1) ═══ */}
              <div ref={fourBtnRowRef} className="home-quick-action-buttons home-quick-action-buttons--layout1">
                <div
                  className="quick-btn quick-btn--newspaper"
                  onClick={() => history.push("/news-paper")}
                >
                  <NewspaperIcon className="quick-btn-icon quick-btn-icon--newspaper" />
                  <span className="quick-btn-label quick-btn-label--newspaper">Newspaper</span>
                </div>
                <div
                  className="quick-btn quick-btn--newschannel"
                  onClick={() => history.push("/news-channel")}
                >
                  <LiveTvIcon className="quick-btn-icon quick-btn-icon--newschannel" />
                  <span className="quick-btn-label quick-btn-label--newschannel">News Channel</span>
                </div>
                <div
                  className="quick-btn quick-btn--online"
                  onClick={() => history.push("/service-link")}
                >
                  <LaptopMacIcon className="quick-btn-icon quick-btn-icon--online" />
                  <span className="quick-btn-label quick-btn-label--online">Online Service</span>
                </div>
                <div
                  className="quick-btn quick-btn--categories"
                  onClick={() => history.push("/category-list-view")}
                >
                  <GridViewIcon className="quick-btn-icon quick-btn-icon--categories" />
                  <span className="quick-btn-label quick-btn-label--categories">All Categories</span>
                </div>
              </div>

              {/* ═══ NEW: Influencer + Recognition BUTTONS (Layout 1) ═══ */}
              <div
                className="home-quick-action-buttons home-quick-action-buttons--layout1 home-influencer-recognition-buttons"
                style={!isMobile && !isTablet ? { width: '100%', display: 'flex', gap: '6px', padding: '0 0 8px 0', boxSizing: 'border-box' } : {}}
              >
                <div
                  className="quick-btn quick-btn--influencer"
                  style={!isMobile && !isTablet && singleBtnWidth ? { flex: 'none', width: `${singleBtnWidth * 1.99044}px`, height: '38.4px' } : {}}
                  onClick={() => history.push("/extra-items/influencers")}
                >
                  <GroupsIcon className="quick-btn-icon quick-btn-icon--influencer" />
                  <span className="quick-btn-label quick-btn-label--influencer">Influencer</span>
                </div>
                <div
                  className="quick-btn quick-btn--recognition"
                  style={!isMobile && !isTablet && singleBtnWidth ? { flex: 'none', width: `${singleBtnWidth * 1.99044}px`, height: '38.4px' } : {}}
                  onClick={() => history.push("/extra-items/others")}
                >
                  <EmojiEventsIcon className="quick-btn-icon quick-btn-icon--recognition" />
                  <span className="quick-btn-label quick-btn-label--recognition">Recognition</span>
                </div>
              </div>

              {/* TRENDING CATEGORIES — desktop only (hidden on mobile via CSS) */}
              <div className="home-tcb-desktop">
                <TrendingCategoriesBar categories={categoryList?.results?.filter(c => c.show_in_home) || []} />
              </div>

            </div>

            <div className={`home-right-slide ${hideCarousels ? "hide" : ""}`}>
              <Box sx={{
                marginTop: { xs: "10px", md: "168px" },
                padding: { xs: "0px 17px", md: "0px" },
                '& .carousel': { '& .slide': { borderRadius: '12px', overflow: 'hidden' } }
              }}>
                <Box sx={{
                  borderRadius: { xs: '10px', md: '12px' },
                  overflow: 'hidden',
                  boxShadow: { xs: '0 4px 12px rgba(0,0,0,0.1)', md: '0 6px 18px rgba(0,0,0,0.28), 0 2px 6px rgba(0,0,0,0.16)' },
                  border: '1px solid rgba(0,0,0,0.05)'
                }}>
                  <HeroCarousel data={premium} />
                </Box>
              </Box>
            </div>

            {/* OLD home-services six-button section removed */}

            <div className="home-slider">
              <SmallCategorySlider
                categories={categoryList?.results || []}
                onCategoryClick={handleClick}
              />
            </div>

            {/* TRENDING CATEGORIES — mobile: after slideshow; desktop: after Influencer/Recognition */}
            <div className="home-tcb-slot">
              <TrendingCategoriesBar categories={categoryList?.results?.filter(c => c.show_in_home) || []} />
            </div>

          </div>

          {/* OLD duplicate desktop button sections removed */}

        </>
      )}

      {isLoading ? (

        <Box sx={{ mt: 3, px: 2 }}>

          {/* Skeleton for Premium Listings Section */}

          <Box sx={{ mb: 3 }}>

            <Skeleton variant="text" width={200} height={32} sx={{ mb: 2 }} />

            <Grid container spacing={2}>

              {[...Array(6)].map((_, index) => (

                <Grid item xs={12} sm={6} md={4} key={index}>

                  <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 2, p: 2 }}>

                    <Skeleton variant="rectangular" width="100%" height={120} sx={{ mb: 1 }} />

                    <Skeleton variant="text" width="80%" height={24} sx={{ mb: 1 }} />

                    <Skeleton variant="text" width="60%" height={20} sx={{ mb: 1 }} />

                    <Skeleton variant="text" width="40%" height={18} />

                  </Box>

                </Grid>

              ))}

            </Grid>

          </Box>



          {/* Skeleton for Trending Categories Section */}

          <Box sx={{ mb: 3 }}>

            <Skeleton variant="text" width={250} height={32} sx={{ mb: 2 }} />

            <Grid container spacing={2}>

              {[...Array(8)].map((_, index) => (

                <Grid item xs={6} sm={4} md={3} key={index}>

                  <Box sx={{ textAlign: 'center' }}>

                    <Skeleton variant="circular" width={60} height={60} sx={{ mx: 'auto', mb: 1 }} />

                    <Skeleton variant="text" width="90%" height={20} sx={{ mx: 'auto' }} />

                  </Box>

                </Grid>

              ))}

            </Grid>

          </Box>



          {/* Loading indicator with animation */}

          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 3 }}>

            <CircularProgress

              size={40}

              thickness={4}

              sx={{

                color: '#7A6327',

                animation: 'pulse 1.5s ease-in-out infinite',

                '@keyframes pulse': {

                  '0%': { transform: 'scale(1)' },

                  '50%': { transform: 'scale(1.1)' },

                  '100%': { transform: 'scale(1)' }

                }

              }}

            />

            <Typography variant="body2" sx={{ mt: 2, color: '#666', fontWeight: 500 }}>

              Loading amazing businesses for you...

            </Typography>

            <Typography variant="caption" sx={{ mt: 1, color: '#999' }}>

              Discover premium listings in your area

            </Typography>

          </Box>

        </Box>

      ) : ''}



      {premium && premium?.length > 0 && (
  <Virtuoso
    className="listing-cards-virtuoso"
    useWindowScroll style={{ height: 'auto' }}
    data={Array.from({ length: Math.ceil(premium.length / 3) }, (_, i) => premium.slice(i * 3, i * 3 + 3))}
    itemContent={(_, row) => (
      <Grid container spacing={0} className="premium-cards-grid">
        {row.map(item => (
          <Grid item xs={12} sm={6} md={4} key={item.id}
                sx={{ maxWidth: { xs: '100%', md: 'calc(33.333% - 2.52px)' }, flexBasis: { xs: '100%', md: 'calc(33.333% - 2.52px)' }, width: { xs: '100%', md: 'calc(33.333% - 2.52px)' } }}>
            <Box sx={{ transform: 'none', transformOrigin: 'center center' }}>
              <ProductCard item={item} isPremiumSection={true} isHomeGrid={layoutMode === "grid"} />
            </Box>
          </Grid>
        ))}
      </Grid>
    )}
    endReached={() => {
      console.log('🚀 Virtuoso endReached triggered');
      console.log('📊 Current state:', { hasMoreBusinesses, loadingMoreBusinesses, isLoading, currentPage: businessPage, totalLoaded: premium.length });
      if (!loadingMoreBusinesses && hasMoreBusinesses && !isLoading) {
        console.log('📦 Loading more businesses via Virtuoso...');
        setLoadingMoreBusinesses(true);
        setBusinessPage(prev => {
          const newPage = prev + 1;
          console.log('📄 New page after increment:', newPage);
          return newPage;
        });
      } else {
        console.log('🛑 Not loading more - conditions not met');
      }
    }}
    components={{
      Footer: () => loadingMoreBusinesses ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '30px 20px', width: '100%', gap: 2 }}>
          <CircularProgress size={32} thickness={3}
            sx={{ color: '#7A6327', animation: 'spin 2s linear infinite', '@keyframes spin': { '0%': { transform: 'rotate(0deg)' }, '100%': { transform: 'rotate(360deg)' } } }} />
          <Typography variant="body2" sx={{ color: '#666', fontWeight: 500 }}>Loading more premium businesses...</Typography>
          <Typography variant="caption" sx={{ color: '#999' }}>Discovering more amazing listings</Typography>
        </Box>
      ) : null,
    }}
  />
)}
        <div style={{ margin: "0 17px" }} className="home-trending-section">

          {/* Increased spacing: columnSpacing 1→1.5, rowSpacing 2→2.5 for less crowded appearance */}
          <Grid container columnSpacing={1.5} rowSpacing={2.5}>

            {categoryList &&

              categoryList?.results?.filter(items => items.show_in_home).map((items, idx) => {

                return (

                  <CategoreyCard

                    id={items.id}

                    title={items.name}

                    image={items.image}

                    handleClick={handleClick}

                    key={idx}

                  />

                );

              })}

          </Grid>

          {/* ── Glass Crystal Buttons: Influencers + Recognitions — mobile + tablet ── */}
          {(isMobile || isTablet) && (
            <div className="glass-btn-row">
              <div
                className="glass-btn glass-btn--influencers"
                onClick={() => history.push("/extra-items/influencers")}
              >
                <GroupsIcon className="glass-btn-icon" />
                <span className="glass-btn-label">Influencers</span>
              </div>
              <div
                className="glass-btn glass-btn--recognitions"
                onClick={() => history.push("/extra-items/others")}
              >
                <EmojiEventsIcon className="glass-btn-icon" />
                <span className="glass-btn-label">Recognitions</span>
              </div>
            </div>
          )}

        </div>

      ) : null}



      {premium && premium?.length > 0 && (
  <div style={{ marginLeft: '-19px' }}>
    <Virtuoso
      className="listing-cards-virtuoso"
      useWindowScroll style={{ height: 'auto' }}
      data={Array.from({ length: Math.ceil(premium.length / 3) }, (_, i) => premium.slice(i * 3, i * 3 + 3))}
      itemContent={(_, row) => (
        <Grid container spacing={0} className="premium-cards-grid">
          {row.map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item.id} sx={{ maxWidth: { xs: '100%', md: 'calc(33.333% - 2.52px)' }, flexBasis: { xs: '100%', md: 'calc(33.333% - 2.52px)' }, width: { xs: '100%', md: 'calc(33.333% - 2.52px)' } }}>
              <Box sx={{ transform: 'none', transformOrigin: 'center center' }}>
                <ProductCard item={item} isPremiumSection={true} isHomeGrid={layoutMode === "grid"} />
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
      endReached={() => {
        console.log('🚀 Virtuoso endReached triggered');
        console.log('📊 Current state:', { hasMoreBusinesses, loadingMoreBusinesses, isLoading, currentPage: businessPage, totalLoaded: premium.length });
        if (!loadingMoreBusinesses && hasMoreBusinesses && !isLoading) {
          console.log('📦 Loading more businesses via Virtuoso...');
          setLoadingMoreBusinesses(true);
          setBusinessPage(prev => {
            const newPage = prev + 1;
            console.log('📄 New page after increment:', newPage);
            return newPage;
          });
        } else {
          console.log('🛑 Not loading more - conditions not met');
        }
      }}
      components={{
        Footer: () => loadingMoreBusinesses ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '30px 20px', width: '100%', gap: 2 }}>
            <CircularProgress size={32} thickness={3}
              sx={{ color: '#7A6327', animation: 'spin 2s linear infinite', '@keyframes spin': { '0%': { transform: 'rotate(0deg)' }, '100%': { transform: 'rotate(360deg)' } } }}
            />
            <Typography variant="body2" sx={{ color: '#666', fontWeight: 500 }}>Loading more premium businesses...</Typography>
            <Typography variant="caption" sx={{ color: '#999' }}>Discovering more amazing listings</Typography>
          </Box>
        ) : null,
      }}
    />
  </div>
)}



  

          

          

            <Virtuoso

              className="listing-cards-virtuoso"

              useWindowScroll style={{ height: 'auto' }}

              data={Array.from({ length: Math.ceil(premium.length / 3) }, (_, i) => premium.slice(i * 3, i * 3 + 3))}

              itemContent={(_, row) => (

                <Grid container spacing={0} className="premium-cards-grid">

                  {row.map((item) => (

                      <Grid item xs={12} sm={6} md={4} key={item.id} sx={{ maxWidth: { xs: '100%', md: 'calc(33.333% - 2.52px)' }, flexBasis: { xs: '100%', md: 'calc(33.333% - 2.52px)' }, width: { xs: '100%', md: 'calc(33.333% - 2.52px)' } }}>
                      <Box sx={{ transform: 'none', transformOrigin: 'center center' }}>
                        <ProductCard item={item} isPremiumSection={true} isHomeGrid={layoutMode === "grid"} />
                      </Box>
                    </Grid>

                  ))}

                </Grid>

              )}

              endReached={() => {

                console.log('🚀 Virtuoso endReached triggered');

                console.log('📊 Current state:', {

                  hasMoreBusinesses,

                  loadingMoreBusinesses,

                  isLoading,

                  currentPage: businessPage,

                  totalLoaded: premium.length

                });



                if (!loadingMoreBusinesses && hasMoreBusinesses && !isLoading) {

                  console.log('📦 Loading more businesses via Virtuoso...');

                  setLoadingMoreBusinesses(true);

                  setBusinessPage(prev => {

                    const newPage = prev + 1;

                    console.log('📄 New page after increment:', newPage);

                    return newPage;

                  });

                } else {

                  console.log('🛑 Not loading more - conditions not met');

                }

              }}

              components={{

                Footer: () => loadingMoreBusinesses ? (

                  <Box sx={{

                    display: 'flex',

                    flexDirection: 'column',

                    alignItems: 'center',

                    justifyContent: 'center',

                    padding: '30px 20px',

                    width: '100%',

                    gap: 2

                  }}>

                    <CircularProgress

                      size={32}

                      thickness={3}

                      sx={{

                        color: '#7A6327',

                        animation: 'spin 2s linear infinite',

                        '@keyframes spin': {

                          '0%': { transform: 'rotate(0deg)' },

                          '100%': { transform: 'rotate(360deg)' }

                        }

                      }}

                    />

                    <Typography variant="body2" sx={{ color: '#666', fontWeight: 500 }}>

                      Loading more premium businesses...

                    </Typography>

                    <Typography variant="caption" sx={{ color: '#999' }}>

                      Discovering more amazing listings

                    </Typography>

                  </Box>

                ) : null

              }}

            />

          



      )}

      <div>

        {premium?.length === 0 && !isLoading ? (

          <div

            style={{

              display: "flex",

              justifyContent: "center",

              alignItems: "center",

              width: "100%",

              position: "relative",

              marginBottom: "80px",

            }}

          >

            <video autoPlay muted width={"100%"} height={"100%"} loop>

              <source src={Empty} type="video/mp4" />

            </video>

          </div>

        ) : null}



        <Box

          className={layoutMode === "grid" ? "home-footer-panel home-footer-panel--grid" : "home-footer-panel"}

          sx={{

            paddingBottom: "80px",

            paddingTop: "5px",

            width: "100%",

            position: "static",

          }}

        >

          <BottomIcons />

        </Box>

      </div>



      <BottomNav />

      {openLocation ? (

        <RegistrationErrorModal

          Toggle={openLocation}

          handleClose={handleClose}

          message="Please provide location to proceed"

          title=""

        />

      ) : null}

    </div>

  );

}



export default React.memo(Home);

